import applicationStore from "../../ApplicationStore";
import RestClient from "../../../integration/RestClient";
import { ActionType } from "../../actions";
import { BookingTolerancesListQuery } from "../../../integrated-client";

export class BookingTolerancesTableActions {
  public static async fetchData(data: BookingTolerancesListQuery) {
    const response =
      await RestClient.bookingTolerances.list.apiBookingTolerancesBookingTolerancesListDataPost(
        {
          bookingTolerancesListQuery: data,
        }
      );
    applicationStore.dispatch({
      type: ActionType.BOOKING_TOLERANCES_TABLE_DATA_FETCHED,
      data: response,
    });
    return response;
  }

  public static async deleteItem(id: string) {
    return await RestClient.bookingTolerances.list.apiBookingTolerancesBookingTolerancesListDeleteDelete(
      {
        id: id,
      }
    );
  }
}
